export interface WebSocketScopeInput {
  terreiroId?: string;
  mediumId?: string;
  scope?: "social";
}

/**
 * The API accepts exactly one websocket scope. `mediumId` only identifies a
 * personal (terreiro-less) medium, so a terreiro context always wins over it.
 */
export const resolveWebSocketScope = ({
  terreiroId,
  mediumId,
  scope,
}: WebSocketScopeInput): WebSocketScopeInput => {
  if (scope) return { scope };
  if (terreiroId) return { terreiroId };
  if (mediumId) return { mediumId };
  return {};
};
